<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';

    import {toastbox} from '../../../utils.js';
    import {validate_int, validate_not_empty} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import FileUpload from "../../parts/FileUpload.svelte";


    let files = ''
    const user = store('credential', 'getAuth');
    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
           // console.log(item)

//Цельностеклянная дверь | 1111x222 | гл.ост.сверху и слева, откр.левое | мат.хром | Прозрачное (M1) 10мм зак. | Ral зажимного:1111 - Глянцевый | Нажимной гарнитур | ширина двери 1212, высота двери 0
//Цельностеклянная дверь | 1111x2222 | откр.левое | мат.хром | Прозрачное (M1) 10мм зак. | Нажимной гарнитур



             let title = item.title.split('| ');

            width.set(+title[1].split('x')[0].trim());
            height.set(+title[1].split('x')[1].trim());

            if (title.length == 8) {
                if (title[7].includes("ширина двери")) {
                    let start = title[7].indexOf("ширина двери") + "ширина двери".length;
                    let part = title[7].slice(start).trim(); // Обрезаем строку после "ширина двери"

                    widthDoor.set(parseInt(part.split(",")[0]) || 0);
                    widthDoorCol.classList.add('show');
                    widthDoorCol.classList.remove('d-none');

                    ind21Col.classList.remove('d-none');

                    ind2 = title[3].trim();

                    const str = title[5];

                    ind21 = +str.substring(str.indexOf('зажимного:') + 'зажимного:'.length, str.indexOf(' - ')).trim(); // Удаляем лишние пробелы
                    ind22 = str.substring(str.indexOf(' - ') + 3).trim(); // Смещаемся на 3 символа (длина " - ")


                }
                else {
                    widthDoorCol.classList.add('d-none');
                    widthDoorCol.classList.remove('show');

                    ind21Col.classList.add('d-none');

                    ind21 ='';
                    ind22='';
                }

                if (title[7].includes("высота двери")) {
                    let start = title[7].indexOf("высота двери") + "высота двери".length;
                    let part = title[7].slice(start).trim();
                    heightDoor.set(parseInt(part.split(",")[0]) || 0);

                    heightDoorCol.classList.add('show');
                    heightDoorCol.classList.remove('d-none');

                    ind21Col.classList.remove('d-none');
                    const str = title[5];
                    ind21 = +str.substring(str.indexOf('зажимного:') + 'зажимного:'.length, str.indexOf(' - ')).trim(); // Удаляем лишние пробелы
                    ind22 = str.substring(str.indexOf(' - ') + 3).trim(); // Смещаемся на 3 символа (длина " - ")

                }
                else {
                    heightDoorCol.classList.add('d-none');
                    heightDoorCol.classList.remove('show');
                }
            }




            if (title[6].trim() == 'Нажимной гарнитур')
            {
                mayatniks = tipNajim;
            }
            else{
                mayatniks=tipTruba;
            }


            if (ind2 == 'мат.хром') {
                ruchki = Object.entries(handleMatHrom)
            }
            else if (ind2 == 'хром') {
                ruchki = Object.entries(handleHrom)
            }
            else {
                ruchki = Object.entries(handleBlack)
            }



            ind1 = title[2].trim().replace(", без замка", "").replace(", с замком", "");

            ind3= title[4].trim();

            ind4= title[6].trim(); // ручка


            count.set(+item.quantity);

            comment.set(item.comment);

            if (title[2].includes('с замком')){
                ind6='Да'
            }
            else{
                ind6='Нет'
            }

            fetchData = await fetch(ind1, ind2);
            change();
        }
    };



    let tipTruba = [

        'откр.левое',
        'откр.правое',
        'штульп',
        'гл.ост.сверху, откр.левое',
        'гл.ост.сверху, откр.правое',
        'гл.ост.справа, откр.левое',
        'штульп, гл.ост.сверху',
        'гл.ост.слева, откр.правое',
        'гл.ост.сверху и слева, откр.правое',
        'гл.ост.сверху и справа, откр.левое',
        'штульп в центре',
        'откр.левое в центре',
        'откр.правое в центре',
        'гл.ост. 2шт слева',
        'гл.ост. по 2шт справа и слева, откр.левое',
        'гл.ост. по 2шт справа и слева, откр.правое',
        'гл.ост. по 2шт справа и слева,1шт.сверху, откр.левое',
        'гл.ост.сверху и слева, откр.левое',
        'гл.ост.сверху и справа, откр.правое',
        'штульп, гл.ост. по 2шт справа и слева,1шт.сверху',
        'штульп, гл.ост.справа и слева по 1ст',
        'штульп, гл.ост.слева 2 стекла',
        'штульп, гл.ост.слева',
        'штульп, гл.ост.справа 2 стекла',
        'штульп, гл.ост.справа и слева по 2 стекла',
        'штульп, гл.ост.справа',
    ]

    let tipNajim = [
        'откр.левое',
        'откр.правое',
        'штульп, акт.правая',
        'штульп, акт.левая',
        'гл.ост.сверху и слева, откр.левое',
        'гл.ост.сверху и слева, откр.правое',
        'штульп, гл.ост.сверху, акт.левая',
        'штульп, гл.ост.сверху, акт.правая',
        'гл.ост.слева',
        'гл.ост.справа',
        'штульп, гл.ост.справа, акт.правая',
        'штульп, гл.ост.слева, акт.левая',
        'гл.ост.сверху и справа, откр.левое',
        'гл.ост.сверху, откр.левое',
        'гл.ост.сверху, откр.правое',
        'гл.ост.сверху и справа, откр.правое',
        'откр.левое в центре',
        'откр.правое в центре',
        'гл.ост. по 2шт справа и слева, откр.левое',
        'гл.ост. по 2шт справа и слева, откр.правое',
        'гл.ост. 2шт слева,акт.правая',
        'гл.ост. 2шт справа,акт.левая',
        'штульп в центре, акт.левая',
        'штульп в центре, акт.правая',
        'штульп, гл.ост. по 2шт справа и слева,1шт.сверху, акт.левая',
        'штульп, гл.ост. по 2шт справа и слева,1шт.сверху, акт.правая',
        'штульп, гл.ост.справа и слева по 1ст, акт.правая',
        'штульп, гл.ост.слева 2 стекла, акт.левая',
        'штульп, гл.ост.справа 2 стекла, акт.правая',
        'штульп, гл.ост.справа и слева по 2 стекла, акт.левая',
        'штульп, гл.ост.справа и слева по 2 стекла, акт.правая',
        'гл.ост. по 2шт справа и слева,1шт.сверху, откр.левое',
        'гл.ост. по 2шт справа и слева,1шт.сверху, откр.правое',
    ]

    const glass = {
        'Прозрачное (M1) 10мм зак.': 'Прозрачное (M1) 10мм зак.',
        'Бронза (AGC) 10мм зак.': 'Бронза (AGC) 10мм зак.',
        'Грей (AGC) 10мм зак.': 'Грей (AGC) 10мм зак.',
        'Матовое 10мм зак.': 'Матовое 10мм зак.',
        'Мультифункциональное (Neutral 67) 10мм зак.': 'Мультифункциональное (Neutral 67) 10мм зак.',
        'Просветленное (AGC) 10мм зак.': 'Просветленное (AGC) 10мм зак.',
    }

    const handleHrom= {
        'Нажимной гарнитур': 'Нажимной гарнитур',
        'Ручка Труба 500 мм (гл. хром) № 622': 'Ручка Труба 500 мм (гл. хром) № 622',
        'Ручка 670 прямая полированная':'Ручка 670 прямая полированная',
        'Ручка 200 Модерн полированная':'Ручка 200 Модерн полированная',
        'Ручка 490 Фиера полированная':'Ручка 490 Фиера полированная',
        'Ручка Эйприл 400 Глянец':'Ручка Эйприл 400 Хром глянец',

    };

    const handleMatHrom = {
        'Нажимной гарнитур': 'Нажимной гарнитур',
        'Ручка Труба 450 мм (мат. хром) № 633': 'Ручка Труба 450 мм (мат. хром) № 633',
        // 'Ручка Труба 800 мм (мат. хром) № 633': 'Ручка Труба 800 мм (мат. хром) № 633',
        // 'Ручка Труба 900 мм (мат. хром) № 650': 'Ручка Труба 900 мм (мат. хром) № 650',
        'Ручка 670 прямая мат.хром':'Ручка 670 прямая мат.хром',
        'Ручка 490 Фиера мат.хром':'Ручка 490 Фиера мат.хром',
        'Ручка Эйприл 400 Хром':'Ручка Эйприл 400 Хром',
    };

    const handleBlack = {
        'Нажимной гарнитур': 'Нажимной гарнитур',
        'Ручка Труба 500 мм (черная) № 622': 'Ручка Труба 500 мм (черная) № 622',
        'Ручка 670 прямая черная':'Ручка 670 прямая черная',
        'Ручка 200 Модерн черная':'Ручка 200 Модерн черная',
        'Ручка 490 Фиера черная':'Ручка 490 Фиера черная',
        'Ручка Эйприл 400 Черная':'Ручка Эйприл 400 Черная',
    };

    const color_type = [
        'Глянцевый',
        'Матовый',
        'Муар',
    ];

    let color = ['мат.хром', 'хром', 'черный'];

    const fetch = async (ind1 = 'гл.ост. по 2шт справа и слева, откр.левое', ind2 = 'хром', ind3 = (ind4 == 'Нажимной гарнитур'? 'Нажимной':'труба' )) => {
        let result = await network.fetch_data('Цельностеклянные двери', ind1.toLowerCase(), ind2, ind3);
        let options = await network.fetch_ind('Цельностеклянные двери');

      // let mayatniks = options.ind1;
        color = options.ind2;

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', ''),
        height = parameter('height', ``),

        widthDoor = parameter('widthDoor', ''),
        heightDoor = parameter('heightDoor', ''),

        widthDoorCol,
        heightDoorCol,
        ind21Col,

        ind1 = 'откр.левое', // открытие
        ind2 = 'мат.хром', // цвет
        ind3 = 'Прозрачное (M1) 10мм зак.', //
        ind4 = 'Нажимной гарнитур', //
        ind6 = 'Нет',
        ind21 = '',
        ind22  = 'Глянцевый',

        mayatniks = tipNajim,

        ruchki = Object.entries(handleMatHrom),

        // другое
        count = parameter('count', 1),
        comment = parameter('comment', '')
    ;

    let fetchData = fetch(ind1, ind2);

    let title;



    const setMayatnik = _.throttle(async (val) => {

    if (val){

        fetchData = fetch(ind1 = val, ind2);

        if ((val.includes('гл.') && (val.includes('слева') || val.includes('справа'))) || val.includes('центр')){
            widthDoorCol.classList.add('show');
            widthDoorCol.classList.remove('d-none');

        }else
        {
            widthDoorCol.classList.add('d-none');
            widthDoorCol.classList.remove('show');

        }

        if ((val.includes('гл.') && (val.includes('сверху'))) || val.includes('центр')){
            heightDoorCol.classList.add('show');
            heightDoorCol.classList.remove('d-none');

        }
        else
        {
            heightDoorCol.classList.add('d-none');
            heightDoorCol.classList.remove('show');
        }

        if (((val.includes('гл.') && (val.includes('слева') || val.includes('справа'))) || val.includes('центр'))
        || ((val.includes('гл.') && (val.includes('сверху'))) || val.includes('центр'))){

            ind21Col.classList.remove('d-none');

        }else
        {
            ind21Col.classList.add('d-none');


        }


        change();
        }
    }, 200)

    const changeInd1= () => {
        // Получаем все изображения на странице
        const images = document.querySelectorAll(".image-select");

        images.forEach(img => {
            if (img.getAttribute("title") === ind1) {
                img.click(); // Выбираем нужное изображение
            }
        });

    };
    const changeInd2 = () => {

        if (ind4 == 'Нажимной гарнитур')
        {
            mayatniks = tipNajim;
        }
        else{
            mayatniks=tipTruba;
        }
        if (ind2 == 'мат.хром') {
            ruchki = Object.entries(handleMatHrom)
        }
        else if (ind2 == 'хром') {
            ruchki = Object.entries(handleHrom)
        }
        else {
            ruchki = Object.entries(handleBlack)
        }

        fetchData = fetch(ind1, ind2);
        change();
    };

    const changeInd4 = () => {
         if (ind4 == 'Нажимной гарнитур'){
             mayatniks = tipNajim;
         }
         else{
             mayatniks=tipTruba;
         }
         fetchData = fetch(ind1, ind2);
         change();
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let quantity = +$count,
            w = +$width,
            h = +$height;

        let wd = +$widthDoor, hd = +$heightDoor;

        let namewdhd= '';
        let namezajim= '';

        if (widthDoorCol?.classList.contains("show")) {
            namewdhd =  'ширина двери ' +  wd;
        }

        if (heightDoorCol?.classList.contains("show")) {
            if (namewdhd){
                namewdhd = namewdhd + ', высота двери '+ hd;
            }
            else{
                namewdhd = 'высота двери '+ hd;
            }
        }
        if (namewdhd){ namewdhd = ' | ' + namewdhd; }

        if(!ind21Col?.classList.contains("d-none")) {
            namezajim = ' | Ral зажимного:' + ind21 + ' - ' + ind22
        }


        let result = {
            type: 'Цельностеклянная дверь',
            name: 'Цельностеклянная дверь',
            subname: [
                $width + 'x' + $height, ' | ', computedValue.replace("-труба", "")  , ' | ',
                ind2, ' | ',ind3  , namezajim , ' | ', ind4, namewdhd,
            ].join(''),
            title: [
                'Цельностеклянная дверь', ' | ',
                $width + 'x' + $height, ' | ', computedValue.replace("-труба", "")  , ' | ',
                ind2, ' | ' ,ind3 , namezajim , ' | ', ind4, namewdhd,
            ].join(''),
            params: {
                ind1: computedValue,
                ind2: [
                    'Цельностеклянная дверь', ' | ',
                    $width + 'x' + $height, ' | ', computedValue.replace("-труба", "")  , ' | ',
                    ind2, ' | ' ,ind3 , ' | Ral зажимного:' , ind21 , ' - ' ,ind22 , ' | ', ind4, namewdhd,
                ].join(''),
                ind3: ind3,
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: `${$comment}`.trim(),
            vStrukture: 72
        };

        _.forEach(data.result, function (el) {
            let item = _.cloneDeep(el);
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль с крышками')) {
                kolvo = ((2 * w + 2 * h)/1000   ).toFixed(3);
            }
            else if  (name.includes('стекло') && name.includes(ind3.toLowerCase())) {
                kolvo = (w * h / 1000000).toFixed(3);
            }
            else if  (name == ind4.toLowerCase()) {
                kolvo = (item.kolvo*1).toFixed(3);
            }

            else if  (name.includes('замок') && ind6=='Да') {
                kolvo = (item.kolvo*1).toFixed(0);
            }

            else {
                if(!name.includes('10мм') && !name.includes('ручка') && !name.includes('замок') ){
                    kolvo = (item.kolvo*1).toFixed(0);
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        // расчитываем материалы
        result.params.ind3 = Object.entries(result.materials)
            .filter(([name, obj]) => (!name.includes('10мм') && !name.includes('макет')))
            .map(([name, obj]) => `${name}: ${Math.trunc(obj.count)}${obj.type}`)
            .join(' | ')
            .replace(/Зажимной профиль с крышками:\s*\d+\s*\S*/g, "Зажимной профиль с крышками");


        //console.log( result.params.ind3 );

        dispatch('item', result);
    }, 250);


    setMayatnik();
    change();


    $: computedValue =
        ind1
        + (ind4 === 'Нажимной гарнитур' ? '' : (ind6 === 'Да' ? ', с замком' : ', без замка'))
        + (ind4 === 'Нажимной гарнитур' ? '' : '-труба');

</script>

    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-12 col-sm-7 text-center">
                <div class="row ">
                    <div class="col-12 col-sm-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label"><span style="font-size: 20px">1️⃣</span> Цвет</label>
                                <select class="form-control form-select" bind:value={ind2}  on:change={() => {ind4 = 'Нажимной гарнитур';  changeInd2();  change()}}>
                                    {#each color as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label"><span style="font-size: 20px">2️</span> Ручка</label>
                                <select class="form-control form-select" bind:value={ind4} on:change={() => {changeInd4(); change()}}>
                                    {#each ruchki as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                    </div>



                </div>
                <div class="row imageRow mt-3">
                    <label class="col-12 form-label"><span style="font-size: 20px">3️⃣</span> Выбор конфигурации</label>
                    {#each mayatniks as img}
                        <img src={`/img/mayatnik/${
                                    img +
                                    (ind4 === 'Нажимной гарнитур' ? '' : (ind6 === 'Да' ? ', с замком' : ', без замка')) +
                                    (ind4 === 'Нажимной гарнитур' ? '' : '-труба')
                                  }.jpg`}
                                title={img}{(ind4 == 'Нажимной гарнитур'? '': (ind6 == 'Да' ? ', с замком' : ', без замка')) }
                                alt={img}{(ind4 == 'Нажимной гарнитур'? '': (ind6 == 'Да' ? ', с замком' : ', без замка')) }
                                class="image-select {ind1 === img ? 'selected' : ''}"
                                on:click={() => setMayatnik(img)}
                        />
                    {/each}
                </div>
            </div>
            <div class="col-12 col-sm-5 text-center" style="padding-top: 11px !important;">
                <label class="form-label">Выбранный вариант</label>
                <select class="form-control form-select my-2"
                        bind:value={computedValue}
                        on:change={(event) => {
                            const selectedValue = event.target.value.replace(", без замка-труба", "").replace(", с замком-труба", "");
                            if (mayatniks.includes(selectedValue)) {
                                setMayatnik(selectedValue);
                                changeInd1(selectedValue);
                            } else {
                                setMayatnik(""); // Сбрасываем, если нет такого значения
                            }
                        }
                }>
                    {#each mayatniks as value}
                        <option value="{value}{(ind4 == 'Нажимной гарнитур'? '': (ind6 == 'Да' ? ', с замком' : ', без замка'))  }{(ind4 == 'Нажимной гарнитур'? '':'-труба' )}">{value}{(ind4 == 'Нажимной гарнитур'? '': (ind6 == 'Да' ? ', с замком' : ', без замка'))  }{(ind4 == 'Нажимной гарнитур'? '':'-труба' )}</option>
                    {/each}
                </select>
                {#if mayatniks.includes(computedValue.replace(", без замка-труба", "").replace(", с замком-труба", ""))}
                    <img src={`/img/mayatnik/${computedValue}.jpg`} alt={ind1} title={ind1} style="width: -webkit-fill-available;max-width: 200px; height: 200px; object-position: center center; object-fit: contain; border: 1px solid #ced4da; border-radius: 6px; padding: 2px;margin-top: 15px !important;margin-bottom: 15px !important;"/>
                {/if}
              <!--  <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 10000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 3000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>-->

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ширина конструкции, мм</label>
                                <input type="number"
                                       class="form-control text-center { $width < 10 ? 'text-danger' : '' } { $width > 50000 ? 'text-danger' : '' }"
                                       step="1"
                                       min="200"
                                       max="50000"
                                       bind:value={$width}
                                       on:focus="{e => e.target.select()}"
                                       use:validate_not_empty={$width}
                                       use:validate_int={$width}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Высота конструкции, мм</label>
                                <input type="number"
                                       class="form-control text-center { $height < 10 ? 'text-danger' : '' } { $height > 6000 ? 'text-danger' : '' }"
                                       step="1"
                                       min="200"
                                       max="6000"
                                       bind:value={$height}
                                       on:focus="{e => e.target.select()}"
                                       use:validate_not_empty={$height}
                                       use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="row">

                    <div class="col-6 d-none" id="widthDoorCol" bind:this={widthDoorCol}>
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ширина дверного проёма, мм</label>
                                <input type="number"
                                       class="form-control text-center  "
                                       step="1"
                                       min="200"
                                       max="30000"
                                       bind:value={$widthDoor}
                                       on:focus="{e => e.target.select()}"
                                        >
                            </div>
                        </div>
                    </div>
                    <div class="col-6 d-none" id="heightDoorCol" bind:this={heightDoorCol}>
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Высота дверного проёма, мм</label>
                                <input type="number"
                                       class="form-control text-center "
                                       step="2"
                                       min="200"
                                       max="5000"
                                       bind:value={$heightDoor}
                                       on:focus="{e => e.target.select()}" >
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">


                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Стекло</label>
                                <select class="form-control form-select" bind:value={ind3}>
                                    {#each Object.entries(glass) as [value, name]}
                                        <option value="{name}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row d-none" id="ind21Col" bind:this={ind21Col}>
                        <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Ral зажимного профиля</label>
                                        <input type="number"
                                               class="form-control"
                                               on:focus="{e => e.target.select()}"
                                               bind:value={ind21} >

                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Тип окрашивания</label>
                                    <select class="form-control form-select" bind:value={ind22} >
                                        {#each color_type as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>

                </div>

                    {#if  ind4 != 'Нажимной гарнитур'}
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Замок</label>
                                    <select class="form-control form-select" bind:value={ind6}>
                                        <option value="Да">Да</option>
                                        <option value="Нет">Нет</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Количество конструкций</label>
                                <input type="number" class="form-control text-center " min="1" bind:value={$count} use:validate_int={count}>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Примечание</label>
                                    <textarea class="form-control" bind:value={$comment}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>



            </div>


        </div>
    </div>


<style>
    .image-select {
        object-position: center center; object-fit: contain;
        height: 85px;
        width: calc(20% - 4px)!important;
        border: 1px solid #ced4da;
        border-radius: 6px;
        margin: 2px;
        padding: 2px;
    }
    @media (min-width:1000px){
        .image-select {
            width: calc(32% - 4px);
        }
    }
    .image-select.selected {
        border-color: #1E74FD;
        border-width: thick;
    }

    label.form-label {
        display: flex;
        align-items: center;
        min-height: 40px;
    }

    /*.imageRow {
        display: grid;
        grid-template-columns: repeat(3, 1fr); !* 3 колонки *!
        gap: 10px; !* Расстояние между изображениями *!
    }

    .image-select {
        width: 100%;
        height: auto;
        transition: all 0.3s ease;
    }

    .image-select.selected {
        grid-column: span 2; !* Растягивает на 2 колонки *!
        grid-row: span 2; !* Растягивает на 2 строки *!
        z-index: 10; !* Поднимает выбранное изображение над остальными *!
    }*/
</style>
